import React from 'react';
import { LISTING_TYPE_LABELS, formatDate, formatPrice, formatPhone } from '../utils/formatters';
import useModalAccessibility from '../hooks/useModalAccessibility';
import './ShiftDetailsModal.css';

const MedallionDetailsModal = ({ post, onClose, userRole }) => {
  const modalRef = useModalAccessibility(onClose);

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        ref={modalRef}
        className="shift-details-modal car-listing-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="medallion-details-title"
      >
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label="Close dialog"
        >
          &times;
        </button>

        {/* Icon + Title Header */}
        <div className="listing-header">
          <div className="listing-icon car-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
            </svg>
          </div>
          <div className="listing-header-info">
            <h2 id="medallion-details-title" className="listing-name">{post.title}</h2>
            <div className="listing-meta">
              <span className="meta-item">{LISTING_TYPE_LABELS[post.listing_type] || post.listing_type}</span>
              <span className="meta-item">{formatDate(post.created_at)}</span>
            </div>
          </div>
        </div>

        {post.description && (
          <p className="shift-description">{post.description}</p>
        )}

        <div className="section-divider" />

        <div className="details-grid">
          {post.price != null && (
            <div className="detail-item">
              <span className="detail-label">Price</span>
              <span className="detail-value highlight">{formatPrice(post.price)}</span>
            </div>
          )}

          {post.quantity > 1 && (
            <div className="detail-item">
              <span className="detail-label">Quantity</span>
              <span className="detail-value">{post.quantity}</span>
            </div>
          )}
        </div>

        {(post.poster_phone || post.poster_email) && (
          <>
            <div className="section-divider" />
            <div className="fleet-section">
              <span className="fleet-label">Contact</span>
              <div className="fleet-info">
                <div className="fleet-avatar">
                  {post.poster_name ? post.poster_name.charAt(0).toUpperCase() : '?'}
                </div>
                <div className="fleet-details">
                  <div className="fleet-details-row">
                    <span className="fleet-name">{post.poster_name}</span>
                  </div>
                  <div className="fleet-details-row">
                    {post.poster_phone && (
                      <span className="fleet-contact-row">
                        <span className="contact-label">Phone:</span>
                        <a href={`tel:${post.poster_phone}`} className="fleet-contact-link">{formatPhone(post.poster_phone)}</a>
                      </span>
                    )}
                    {post.poster_email && (
                      <span className="fleet-contact-row">
                        <span className="contact-label">Email:</span>
                        <a href={`mailto:${post.poster_email}`} className="fleet-contact-link">{post.poster_email}</a>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="modal-actions">
          <button className="btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedallionDetailsModal;
